import { render, staticRenderFns } from "./currency-display.vue?vue&type=template&id=54e78bea&scoped=true&"
import script from "./currency-display.vue?vue&type=script&lang=js&"
export * from "./currency-display.vue?vue&type=script&lang=js&"
import style0 from "./currency-display.vue?vue&type=style&index=0&id=54e78bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e78bea",
  null
  
)

export default component.exports